<template>
    <div style="height: 100%">
        <div v-if="params.data.time_worked > params.data.time_planned" style="height: 100%">
            <vs-chip class="mr-3" style="height: 60%; top:20%" color="danger">{{ params.value }}h</vs-chip>
        </div>
        <div v-else>
            {{ params.value }}h
        </div>
    </div>
</template>
<script>
    import Vue from "vue";

    export default Vue.extend({
    });

</script>
